import { Box, Link, Typography } from "@mui/material";

import { Button, Modal } from "@covertree/ui";

import { AGENT_HELP_ADDRESS } from "@consts/index";

interface DefaultErrorModalProps {
  readonly isModalOpen: boolean;
  readonly onClose: () => void;
}

export function DefaultErrorModal({
  isModalOpen,
  onClose,
}: DefaultErrorModalProps) {
  return (
    <Modal
      open={isModalOpen}
      onClose={onClose}
      title="Something Went Wrong"
      maxWidth={false}
      sx={{
        width: { xs: "80%", md: 720 },
        "&:focus": {
          outline: "none",
        },
      }}>
      <Typography variant="h5" sx={{ pr: 5, textAlign: "justify" }}>
        Sorry, something went wrong.
        <br />
        Please try again or email us at{" "}
        <Link color="secondary" href={`mailto:${AGENT_HELP_ADDRESS}`}>
          {AGENT_HELP_ADDRESS}
        </Link>
        .
      </Typography>
      <Box mt={4} columnGap={3} display="flex">
        <Button onClick={onClose}>Close</Button>
      </Box>
    </Modal>
  );
}
